import * as i0 from '@angular/core';
import * as i1 from './index';
import * as i2 from './alert/alert';
import * as i3 from './buttons/label';
import * as i4 from './buttons/checkbox';
import * as i5 from './buttons/radio';
import * as i6 from './collapse/collapse';
import * as i7 from './progressbar/progressbar';
import * as i8 from './tooltip/tooltip';
import * as i9 from './typeahead/typeahead';
import * as i10 from './typeahead/highlight';
import * as i11 from './accordion/accordion';
import * as i12 from './carousel/carousel';
import * as i13 from './datepicker/datepicker';
import * as i14 from './datepicker/datepicker-input';
import * as i15 from './dropdown/dropdown';
import * as i16 from './pagination/pagination';
import * as i17 from './popover/popover';
import * as i18 from './rating/rating';
import * as i19 from './tabset/tabset';
import * as i20 from './timepicker/timepicker';
import * as i21 from './alert/alert.module';
import * as i22 from './buttons/buttons.module';
import * as i23 from './collapse/collapse.module';
import * as i24 from './progressbar/progressbar.module';
import * as i25 from './tooltip/tooltip.module';
import * as i26 from './typeahead/typeahead.module';
import * as i27 from './accordion/accordion.module';
import * as i28 from './carousel/carousel.module';
import * as i29 from './datepicker/datepicker.module';
import * as i30 from './dropdown/dropdown.module';
import * as i31 from './modal/modal.module';
import * as i32 from './pagination/pagination.module';
import * as i33 from './popover/popover.module';
import * as i34 from './rating/rating.module';
import * as i35 from './tabset/tabset.module';
import * as i36 from './timepicker/timepicker.module';
export const NgbRootModuleNgFactory:i0.NgModuleFactory<i1.NgbRootModule> = (null as any);
var _decl0_0:i2.NgbAlert = (<any>(null as any));
var _decl0_1:i3.NgbButtonLabel = (<any>(null as any));
var _decl0_2:i4.NgbCheckBox = (<any>(null as any));
var _decl0_3:i5.NgbRadioGroup = (<any>(null as any));
var _decl0_4:i5.NgbRadio = (<any>(null as any));
var _decl0_5:i6.NgbCollapse = (<any>(null as any));
var _decl0_6:i7.NgbProgressbar = (<any>(null as any));
var _decl0_7:i8.NgbTooltip = (<any>(null as any));
var _decl0_8:i9.NgbTypeahead = (<any>(null as any));
var _decl0_9:i10.NgbHighlight = (<any>(null as any));
var _decl0_10:i11.NgbAccordion = (<any>(null as any));
var _decl0_11:i11.NgbPanel = (<any>(null as any));
var _decl0_12:i11.NgbPanelTitle = (<any>(null as any));
var _decl0_13:i11.NgbPanelContent = (<any>(null as any));
var _decl0_14:i12.NgbCarousel = (<any>(null as any));
var _decl0_15:i12.NgbSlide = (<any>(null as any));
var _decl0_16:i13.NgbDatepicker = (<any>(null as any));
var _decl0_17:i14.NgbInputDatepicker = (<any>(null as any));
var _decl0_18:i15.NgbDropdown = (<any>(null as any));
var _decl0_19:i15.NgbDropdownAnchor = (<any>(null as any));
var _decl0_20:i15.NgbDropdownToggle = (<any>(null as any));
var _decl0_21:i15.NgbDropdownMenu = (<any>(null as any));
var _decl0_22:i16.NgbPagination = (<any>(null as any));
var _decl0_23:i17.NgbPopover = (<any>(null as any));
var _decl0_24:i18.NgbRating = (<any>(null as any));
var _decl0_25:i19.NgbTabset = (<any>(null as any));
var _decl0_26:i19.NgbTab = (<any>(null as any));
var _decl0_27:i19.NgbTabContent = (<any>(null as any));
var _decl0_28:i19.NgbTabTitle = (<any>(null as any));
var _decl0_29:i20.NgbTimepicker = (<any>(null as any));
var _decl0_49:i21.NgbAlertModule = (<any>(null as any));
var _decl0_50:i22.NgbButtonsModule = (<any>(null as any));
var _decl0_52:i23.NgbCollapseModule = (<any>(null as any));
var _decl0_58:i24.NgbProgressbarModule = (<any>(null as any));
var _decl0_62:i25.NgbTooltipModule = (<any>(null as any));
var _decl0_63:i26.NgbTypeaheadModule = (<any>(null as any));
var _decl0_48:i27.NgbAccordionModule = (<any>(null as any));
var _decl0_51:i28.NgbCarouselModule = (<any>(null as any));
var _decl0_53:i29.NgbDatepickerModule = (<any>(null as any));
var _decl0_54:i30.NgbDropdownModule = (<any>(null as any));
var _decl0_55:i31.NgbModalModule = (<any>(null as any));
var _decl0_56:i32.NgbPaginationModule = (<any>(null as any));
var _decl0_57:i33.NgbPopoverModule = (<any>(null as any));
var _decl0_59:i34.NgbRatingModule = (<any>(null as any));
var _decl0_60:i35.NgbTabsetModule = (<any>(null as any));
var _decl0_61:i36.NgbTimepickerModule = (<any>(null as any));
var _decl0_64:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_65:i0.ElementRef<any> = (<any>(null as any));
export const NgbModuleNgFactory:i0.NgModuleFactory<i1.NgbModule> = (null as any);
var _decl1_0:i11.NgbAccordion = (<any>(null as any));
var _decl1_1:i11.NgbPanel = (<any>(null as any));
var _decl1_2:i11.NgbPanelTitle = (<any>(null as any));
var _decl1_3:i11.NgbPanelContent = (<any>(null as any));
var _decl1_4:i2.NgbAlert = (<any>(null as any));
var _decl1_5:i3.NgbButtonLabel = (<any>(null as any));
var _decl1_6:i4.NgbCheckBox = (<any>(null as any));
var _decl1_7:i5.NgbRadioGroup = (<any>(null as any));
var _decl1_8:i5.NgbRadio = (<any>(null as any));
var _decl1_9:i12.NgbCarousel = (<any>(null as any));
var _decl1_10:i12.NgbSlide = (<any>(null as any));
var _decl1_11:i6.NgbCollapse = (<any>(null as any));
var _decl1_12:i13.NgbDatepicker = (<any>(null as any));
var _decl1_13:i14.NgbInputDatepicker = (<any>(null as any));
var _decl1_14:i15.NgbDropdown = (<any>(null as any));
var _decl1_15:i15.NgbDropdownAnchor = (<any>(null as any));
var _decl1_16:i15.NgbDropdownToggle = (<any>(null as any));
var _decl1_17:i15.NgbDropdownMenu = (<any>(null as any));
var _decl1_18:i16.NgbPagination = (<any>(null as any));
var _decl1_19:i17.NgbPopover = (<any>(null as any));
var _decl1_20:i7.NgbProgressbar = (<any>(null as any));
var _decl1_21:i18.NgbRating = (<any>(null as any));
var _decl1_22:i19.NgbTabset = (<any>(null as any));
var _decl1_23:i19.NgbTab = (<any>(null as any));
var _decl1_24:i19.NgbTabContent = (<any>(null as any));
var _decl1_25:i19.NgbTabTitle = (<any>(null as any));
var _decl1_26:i20.NgbTimepicker = (<any>(null as any));
var _decl1_27:i8.NgbTooltip = (<any>(null as any));
var _decl1_28:i9.NgbTypeahead = (<any>(null as any));
var _decl1_29:i10.NgbHighlight = (<any>(null as any));
var _decl1_46:i27.NgbAccordionModule = (<any>(null as any));
var _decl1_47:i21.NgbAlertModule = (<any>(null as any));
var _decl1_48:i22.NgbButtonsModule = (<any>(null as any));
var _decl1_49:i28.NgbCarouselModule = (<any>(null as any));
var _decl1_50:i23.NgbCollapseModule = (<any>(null as any));
var _decl1_51:i29.NgbDatepickerModule = (<any>(null as any));
var _decl1_52:i30.NgbDropdownModule = (<any>(null as any));
var _decl1_53:i31.NgbModalModule = (<any>(null as any));
var _decl1_54:i32.NgbPaginationModule = (<any>(null as any));
var _decl1_55:i33.NgbPopoverModule = (<any>(null as any));
var _decl1_56:i24.NgbProgressbarModule = (<any>(null as any));
var _decl1_57:i34.NgbRatingModule = (<any>(null as any));
var _decl1_58:i35.NgbTabsetModule = (<any>(null as any));
var _decl1_59:i36.NgbTimepickerModule = (<any>(null as any));
var _decl1_60:i25.NgbTooltipModule = (<any>(null as any));
var _decl1_61:i26.NgbTypeaheadModule = (<any>(null as any));
var _decl1_62:i0.TemplateRef<any> = (<any>(null as any));
var _decl1_63:i0.ElementRef<any> = (<any>(null as any));
